import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tip } from '../../models/tip.model';
import { TipService } from '../../services/tip.service';
import { FormatTimestampPipe } from '../../pipes/format-timestamp.pipe';

@Component({
  selector: 'app-recent-tips',
  standalone: true,
  imports: [CommonModule, FormatTimestampPipe],
  templateUrl: './recent-tips.component.html',
  styleUrl: './recent-tips.component.css'
})
export class RecentTipsComponent implements OnInit {
  tips: Tip[] = [];

  constructor(private tipService: TipService) { }

  ngOnInit(): void {
    this.tipService.getRecentTips().subscribe(tips => {
      this.tips = tips;
    });
  }
}